import { render, staticRenderFns } from "./Geometry.vue?vue&type=template&id=8981e31c&scoped=true"
import script from "./Geometry.vue?vue&type=script&lang=ts"
export * from "./Geometry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8981e31c",
  null
  
)

export default component.exports